// src/components/MessageList.js
import React, { useEffect, useRef } from 'react';
import Message from './Message'; // Assicurati che Message sia importato
// import MuvingAnimation from './MuvingAnimation'; // NO LONGER NEEDED HERE

function MessageList({ messages }) {
  const messagesEndRef = useRef(null); 

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]); 

  return (
    <div className="message-list">
      {messages.map((msg) => (
        <Message key={msg.id} message={msg} /> 
      ))}
      {/* No separate MuvingAnimation here. Message.js handles its loading state. */}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default MessageList;